export const stats = [
	{ value: '0%', label: 'Agency Markup' },
	{ value: '10+', label: 'Years in Tech' },
	{ value: '1:1', label: 'Personal Attention' },
	{ value: '12+', label: 'Years in Automation & Tech' },
];
